import { HomePageBannerProduct } from '@/modules/home/api';
import { convertImportFlagToString } from '@/shared/utils/convert-import-flag-to-string';
import { productName } from '@/shared/utils/product-name';

export const imageBreakpoints: Record<number, number | number[]> = {
  1920: 500,
  1680: 500,
  1600: 500,
  1536: 500,
  1440: 500,
  1366: 400,
  1280: 400,
  428: [400, 500, 600],
  414: [400, 500, 600],
  412: [400, 500, 600],
  393: [350, 400, 500],
  390: [350, 400, 500],
  385: [350, 400, 500],
  384: [350, 400, 500],
  375: [350, 400, 500],
  360: [350, 400, 500],
  320: [300, 400, 500],
};

export function mapHomePageBannerProductToGtmPromotionEventItem(
  product: HomePageBannerProduct & { index?: number },
  index: number,
  itemListName: string,
  itemListId: string
) {
  const categories =
    product.category_home_path.length > 0
      ? product.category_home_path.reduce(
          (prevValue, category, categoryIndex) => {
            const keyCategory =
              categoryIndex === 0
                ? 'item_category'
                : `item_category${categoryIndex + 1}`;
            return {
              ...prevValue,
              [keyCategory]: category.name,
            };
          },
          {}
        )
      : {};

  return {
    index: index,
    item_brand: product.brand_name,
    item_id: product.product_id,
    item_list_id: itemListId,
    item_list_name: itemListName,
    item_name: productName(product),
    price: product.price / 100,
    import: convertImportFlagToString(product.importFlag),
    ...categories,
  };
}
